import { render, staticRenderFns } from "./discardConfirmationModal.vue?vue&type=template&id=2fd0c93a&"
import script from "./discardConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./discardConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./discardConfirmationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports